'use strict'

/**
 * Vue Club/ProblemeTechnique
 */

import master from 'Modules/master'

master.process()

/**
 * Récupère les données du navigateur de l'utilisateur et les stocke dans l'input
 */
const J_TARGET = '.j_infoJs'

let result = ''

result += 'Cookies Enabled: ' + navigator.cookieEnabled
result += '\r\nBrowser Engine: ' + navigator.product
result += '\r\nBrowser AppName: ' + navigator.appName
result += '\r\nBrowser CodeName: ' + navigator.appCodeName
result += '\r\nBrowser Version: ' + navigator.appVersion
result += '\r\nBrowser UserAgent: ' + navigator.userAgent
result += '\r\nOperating System: ' + navigator.platform
result += '\r\nBrowser Language: ' + navigator.language

$(J_TARGET).val(result)
